import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styles from './style.css';

class CanvasComponentsCanvasItem extends PureComponent {

  static propTypes = {
    canvas: PropTypes.any,
    size: PropTypes.any
  };

  render() {
    let imageStyles = {
      maxWidth: '50px',
      maxHeight: '70px',
      height: 'auto'
    };
    if (this.props.size) {
      imageStyles = {
        width: this.props.size.width,
        height: this.props.size.height
      };
    }

    return (
      <div className={styles.container}>
        <img src={this.props.canvas.path}
             className={styles.image}
             style={imageStyles} />
      </div>
    )
  }
}

export default CanvasComponentsCanvasItem;